import { Alert, Chip, Skeleton, Snackbar } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.scss";
// import {JobsList} from "../../../components/JobPricing/Jobs/index.tsx";
// import GradesList from "../../../components/JobPricing/Grades/index.tsx";
import { useDispatch, useSelector } from "react-redux";
import Header from "../Header/index";
// import FunctionsList from "../../../components/JobPricing/Functions/index";
import {
  JobPricingCategory,
  JobPricingListTabLabel
} from "../../../constants/JobPricingReportConstants";
import { RootState } from "../../../store/reducers";
import { getCustomGradesFiltersThunk } from "../../../store/slices/customGradesSlice";
import { updateJobPricingPayloads } from "../../../store/slices/jobPricingSearchSlice";
import {
  resetFilters,
  resetFiltersCount,
  resetJobCatogery,
  resetJobPricingList,
  resetPeerGroupId,
  resetSearchKey,
  updateApiFailed,
  updateFilters,
  updateJobCatogery,
  resetSelectedPeerGroup
} from "../../../store/slices/SJPR/listSlice";
import FunctionsList from "../Functions";
import GradesList from "../Grades";
import { ChipsWithDropdown } from "../Header/chip-dropdown";
import JobsList from "../Jobs";

import { resetPricingDetailsState } from "../../../store/slices/jobPricingDetailsSlice";
import { resetReportSearchState } from "../../../store/slices/jobPricingSearchSlice";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const SearchResults = () => {
  const { t } = useTranslation();
  const [value, setValue] = useState<any>(0);
  const dispatch = useDispatch();
  const { category, list, isListloading, isApiFailed } = useSelector(
    (state: any) => {
      return state?.jobPricingList;
    }
  );
  const { selectedCountry } = useSelector((state: RootState) => state.country);

  const { customGrades, isCustomGradesLoading } = useSelector(
    (state: RootState) => state.customGrades
  );

  const [selectedCustomGrades, setSelectedCustomGrades] = useState<any[]>([]);
  const [appliedCustomGrades, setAppliedCustomGrades] = useState<any[]>([]); // Add this new state

  const mapCustomGradesToKeyLabel = (customGradesArray: any[]) => {
    if (!customGradesArray) return [];
    return customGradesArray.map((customGrade) => ({
      key:
        customGrade.gradesetid === null || customGrade.gradesetid === undefined
          ? ""
          : String(customGrade.gradesetid),
      label: customGrade.gradesetname || ""
    }));
  };

  const mappedCustomGrades = customGrades?.data?.data?.grades
    ? mapCustomGradesToKeyLabel(customGrades.data.data.grades)
    : [];

  const onCustomGradeChange = (option: any, action?: string) => {
    console.log("option", option);
    if (option === "CLEAR_ALL") {
      setSelectedCustomGrades([]);
      return;
    }

    const selectedFilter = [...selectedCustomGrades];

    if (option?.key === "ALL") {
      const isAllSelected = selectedFilter.some((opt) => opt.key === "ALL");
      if (isAllSelected) {
        setSelectedCustomGrades([]);
      } else {
        setSelectedCustomGrades([
          ...mappedCustomGrades,
          { key: "ALL", label: t("pa.selectAll") }
        ]);
      }
      return;
    }

    const isItemSelected = selectedFilter.some(
      (item) => item.key === option?.key
    );

    if (isItemSelected) {
      setSelectedCustomGrades(
        selectedFilter.filter(
          (item) => item.key !== option.key && item.key !== "ALL"
        )
      );
    } else {
      setSelectedCustomGrades([...selectedFilter, option]);
    }
  };

  const onCustomGradeClose = (event: any, reason: string) => {
    if (reason === "CLEAR_ALL") {
      setSelectedCustomGrades([]);
      setAppliedCustomGrades([]);
      dispatch(updateFilters({ customGradeId: "" }));
      dispatch(resetJobPricingList());
      return;
    }
    const selectedGradeIds = selectedCustomGrades
      .filter((grade) => grade.key !== "ALL")
      .map((grade) => grade.key)
      .join(",");
    setAppliedCustomGrades(
      selectedCustomGrades.filter((grade) => grade.key !== "ALL")
    );
    dispatch(updateFilters({ customGradeId: selectedGradeIds }));
    dispatch(resetJobPricingList());
  };

  const handleRemoveAppliedGrade = (gradeToRemove: any) => {
    const updatedApplied = appliedCustomGrades.filter(
      (grade) => grade.key !== gradeToRemove.key
    );
    const updatedSelected = selectedCustomGrades.filter(
      (grade) => grade.key !== gradeToRemove.key && grade.key !== "ALL"
    );

    setAppliedCustomGrades(updatedApplied);
    setSelectedCustomGrades(updatedSelected);

    const selectedGradeIds = updatedApplied.map((grade) => grade.key).join(",");
    dispatch(updateFilters({ customGradeId: selectedGradeIds }));
    dispatch(resetJobPricingList());
  };

  const updateJobCatogeryFunc = (value: number) => {
    const cat = [
      JobPricingCategory.JOB,
      JobPricingCategory.FUNCTION,
      JobPricingCategory.GRADE
    ];
    const selecteCat = value && value < 3 ? cat[value] : cat[0];
    dispatch(updateJobCatogery(selecteCat));
  };

  const handleChange = (event: any, newValue: number) => {
    updateJobCatogeryFunc(newValue);
    setValue(newValue);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`
    };
  };

  const RenderTabHeader = (label: string) => {
    const { jobNameCount, jobFamilyCount, gradeCount } = list?.tabCount || {};
    switch (label) {
      case "Jobs":
        return `${t("pa.jobs")} (${!isListloading ? jobNameCount || 0 : " "})`;
      case "Functions":
        return `${t("pa.functions")} (${!isListloading ? jobFamilyCount || 0 : " "})`;
      case "Grades":
        return `${t("pa.grades")} (${!isListloading ? gradeCount || 0 : " "})`;
    }
  };

  const handleCloseApiFailedMsg = () => {
    dispatch(updateApiFailed(false));
  };

  useEffect(() => {
    dispatch(resetFilters());
    dispatch(resetPeerGroupId());
    // dispatch(resetSelectedPeerGroup());
    dispatch(resetPricingDetailsState());
    dispatch(resetReportSearchState());
    dispatch(
      updateJobPricingPayloads({ countryCode: selectedCountry?.key || "" })
    );
    // if (selectedCountry?.key) {
    //   dispatch(
    //     getCustomGradesFiltersThunk({
    //       countryCode: selectedCountry?.key
    //     })
    //   );
    // }
    return () => {
      dispatch(resetSearchKey());
      sessionStorage.removeItem("searchKey");
      dispatch(resetFiltersCount());
      dispatch(resetJobPricingList());
    };
  }, []);

  useEffect(() => {
    switch (category) {
      case JobPricingCategory.JOB:
        setValue(0);
        break;
      case JobPricingCategory.FUNCTION:
        setValue(1);
        break;
      case JobPricingCategory.GRADE:
        setValue(2);
        break;
      default:
        setValue(0);
    }
  }, []);

  useEffect(() => {
    if (category == JobPricingCategory.GRADE) {
      setValue(2);
    }
  }, [category]);

  return (
    <div className="search-results-container">
      {/* <SearchFilters />
      <div>detailed block put all tabs layout</div>
      <div>Tab detail load component</div> */}
      <Header />
      <div className="tabs-block">
        <Box sx={{ width: "100%" }}>
          <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              textColor="secondary"
              indicatorColor="secondary"
              aria-label="secondary tabs example"
            >
              <Tab
                label={RenderTabHeader(JobPricingListTabLabel.JOB)}
                {...a11yProps(0)}
              />
              <Tab
                label={RenderTabHeader(JobPricingListTabLabel.FUNCTION)}
                {...a11yProps(1)}
              />
              <Tab
                label={RenderTabHeader(JobPricingListTabLabel.GRADE)}
                {...a11yProps(2)}
              />
            </Tabs>
            {/* {(value === 1 || value === 2) && (
              <Box
                sx={{
                  padding: "16px 32px",
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 1
                }}
              >
                {isCustomGradesLoading ? (
                  <Skeleton
                    variant="rectangular"
                    width={200}
                    height={35}
                    sx={{ borderRadius: 30 }}
                  />
                ) : mappedCustomGrades.length > 0 ? (
                  <>
                    <ChipsWithDropdown
                      key="custom-grades"
                      name="customGradeId"
                      label="Custom Grades"
                      options={mappedCustomGrades}
                      values={selectedCustomGrades}
                      count={appliedCustomGrades.length}
                      onChipChange={(option: any, action: string) => {
                        onCustomGradeChange(option, action);
                      }}
                      onClose={(event: any, reason: string) => {
                        onCustomGradeClose(event, reason);
                      }}
                    />
                    {appliedCustomGrades.length > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0.5,
                          ml: 1
                        }}
                      >
                        {appliedCustomGrades.map((grade) => (
                          <Chip
                            key={grade.key}
                            label={grade.label}
                            size="small"
                            onDelete={() => handleRemoveAppliedGrade(grade)}
                            sx={{
                              backgroundColor: "var(--primary-color)",
                              color: "#fff",
                              "& .MuiChip-deleteIcon": {
                                color: "#fff",
                                "&:hover": {
                                  color: "#ddd"
                                }
                              }
                            }}
                          />
                        ))}
                      </Box>
                    )}
                  </>
                ) : null}
              </Box>
            )} */}
          </Box>{" "}
          <CustomTabPanel value={value} index={0}>
            <JobsList />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <FunctionsList />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            <GradesList />
          </CustomTabPanel>
        </Box>
      </div>
      <Snackbar
        open={isApiFailed}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={3000}
        onClose={handleCloseApiFailedMsg}
      >
        <Alert
          onClose={handleCloseApiFailedMsg}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("pa.sjpr.serviceApiFailedMsg")}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SearchResults;
